var _dec, _dec2, _class, _class2;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@ember/component';
import { action } from '@ember/object';
import { tagName, layout as templateLayout } from '@ember-decorators/component';
import { isIOS, clickHandlerDelay } from '../utils/config-utils';
import layout from '../templates/components/overlay';
let OverlayComponent = (_dec = tagName(''), _dec2 = templateLayout(layout), _dec(_class = _dec2(_class = (_class2 = class OverlayComponent extends Component {
  _onClickOverlay(event) {
    let {
      onClickOverlay
    } = this;
    if (onClickOverlay) {
      onClickOverlay(event);
    }
  }
  didInsert(element) {
    const registerClick = () => {
      element.addEventListener('click', this._onClickOverlay);
    };

    // setTimeout needed or else the click handler will catch the click that spawned this modal dialog
    setTimeout(registerClick, clickHandlerDelay(this));
    if (isIOS) {
      element.style.cursor = 'pointer';
    }
  }
  willDestroyNode(element) {
    element.removeEventListener('click', this._onClickOverlay);
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "_onClickOverlay", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "_onClickOverlay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "didInsert"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "willDestroyNode", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "willDestroyNode"), _class2.prototype)), _class2)) || _class) || _class);
export { OverlayComponent as default };